module.exports = "<dt-content-header state-title=\"'Notifications'\"></dt-content-header> <div layout=row layout-align=\"start start\" lex> <div class=placeholder-block layout-margin> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=placeholder-block__content flex=60> <img src=/assets/images/all-notifications.png class=placeholder-block__image alt=\"This functionality don't supported\"> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/notifications/notifications.html
// module id = JfqN
// module chunks = 1